import { editEmailTemplateService, getEmailTemplatesService } from '../../services/emailSettingsService';

export const GetEmailSettings = async (dispatch) => {
    try {
        dispatch({ type: 'REQUEST_EMAIL_SETTINGS' });
        let response = await getEmailTemplatesService();
        if (response.data) {
            dispatch({ type: 'EMAIL_SETTINGS_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'EMAIL_SETTINGS_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'EMAIL_SETTINGS_ERROR', error: error.response?.data?.error });
    }
};

export const EditEmailSettings = async (dispatch, data) => {
    try {
        dispatch({ type: 'REQUEST_EMAIL_SETTINGS' });
        let response = await editEmailTemplateService(data);
        if (response.data) {
            dispatch({ type: 'EDIT_EMAIL_SETTINGS_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'EMAIL_SETTINGS_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'EMAIL_SETTINGS_ERROR', error: error.response?.data?.error });
    }
};
